module.exports = __webpack_public_path__ + "img/light-brain.a4e17c91.png";